import React from 'react';
import {
  CardHeader,
  CardHeaderText,
  CardHeaderTitle
} from 'components/card/card-header';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import CardBody from 'components/card/CardBody';
import MediaViewer from 'containers/partials/media/MediaViewer';
import { isMzhUserAgent } from 'utils/browser';
import { sortByArray } from 'utils/sort';
import Cues from 'containers/partials/inputs/Cues';
import Card from 'components/card/Card';

const getNote = (exercise, notes) => {
  if (notes && notes.length > 0) {
    return notes[0].note;
  }
  if (exercise?.note) {
    return exercise.note;
  }
  return '';
};

const ExerciseCard = ({ entityId, exercise, program }) => {
  return (
    <Card secondary multiBody>
      <CardHeader extraClassNames="u-margin-bottom-none" secondary>
        <CardHeaderText>
          <CardHeaderTitle>
            <FormattedMessage {...messages.exercisesLabelNotes} />
          </CardHeaderTitle>
        </CardHeaderText>
      </CardHeader>

      <CardBody secondary separatorBottom>
        {/* NOTES */}
        <div className={'c-input__group c-input--closed c-input--read-only'}>
          <div className="c-input--textarea-readonly">
            {getNote(exercise, program?.notes[exercise.id])}
          </div>
        </div>
      </CardBody>
      {/* MEDIA */}
      <CardBody
        secondary
        separatorBottom
        extraClassNames={'c-card__body--media'}
      >
        <div className="c-media c-media--main">
          <MediaViewer
            accentColor={isMzhUserAgent() && '#23387c'}
            entityId={entityId}
            id={exercise.id}
            media={
              exercise.media.length > 0
                ? exercise.meta?.order
                  ? sortByArray(exercise.media, exercise.meta.order)
                  : exercise.media
                : []
            }
          />
        </div>
      </CardBody>
      <CardHeader extraClassNames="u-margin-bottom-none" secondary>
        <CardHeaderText>
          <CardHeaderTitle>
            <FormattedMessage {...messages.exercisesLabelCues} />
          </CardHeaderTitle>
        </CardHeaderText>
      </CardHeader>
      <CardBody secondary separatorBottom>
        {/* CUES */}
        <Cues entityId={entityId} cues={exercise.cues} readOnly={true} />
      </CardBody>
    </Card>
  );
};

export default ExerciseCard;
